import { orange } from '@material-ui/core/colors';
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(() => ({
  typography: {
    letterSpacing: 10,
    fontWeight: 600,
    fontSize: 200
  },
}));

export default function NoMatch() {
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={0}
      align="center"
      justify="center"
      direction="column"
      style={{
        flexGrow: 1,
      }}
    >
      <Grid item>
        <Typography
          variant="h1"
          align="center"
          style={{ display: "inline-block", color: "#263479" }}
          className={classes.typography}
        >
          4
        </Typography>
        <Typography
          variant="h1"
          align="center"
          style={{
            display: "inline-block", color: "#1D57A5"
          }}
          className={classes.typography}
        >
          0
        </Typography>
        <Typography
          variant="h1"
          color="secondary"
          align="center"
          style={{
            display: "inline-block", color: "#13639A"
          }}
          className={classes.typography}
        >
          4
        </Typography>
        <Typography
          variant="h3"
          align="center"
          style={{
            color: orange[500]
          }}
        >
          NOT FOUND
        </Typography>
        <Typography
          variant="body2"
          align="center"
          style={{
            color: orange[500]
          }}
        >
          ALAMAT YANG DIMINTA TIDAK DAPAT DITEMUKAN DALAM DOMAIN INI
        </Typography>
      </Grid>
    </Grid>
  );
}
